// @flow
import { Api } from 'core/services/api'

import type { UpdateUserInterestsRequest, UserInterests } from './types'

export const getUserInterests = async () => {
  const { data } = await Api.get<void, UserInterests>('/api/user/user_interest')

  return data
}

export const updateUserInterests = (data: UpdateUserInterestsRequest) =>
  Api.put<{| user_interest: UpdateUserInterestsRequest |}, void>('/api/user/user_interest', { user_interest: data })
